import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Logo } from '../ui/Logo';

interface NavbarLogoProps {
  isDashboardPage: boolean;
}

export const NavbarLogo: React.FC<NavbarLogoProps> = ({ isDashboardPage }) => {
  const navigate = useNavigate();

  return (
    <div
      className={`flex items-center cursor-pointer group transition-all duration-500 ease-in-out ${isDashboardPage ? 'lg:ml-0 lg:absolute lg:left-20' : ''}`}
      onClick={() => navigate('/')}
    >
      <Logo width={74} variant="default" />
    </div>
  );
}; 